import React from 'react';
import { ORDER_STATUS_OPTIONS } from '../common/constants';
import SelectComponent from './SelectComponent';

const OrderStatusSelect = ({
  finalWhereFiltersRef,
  finalWhereFilters,
  setFinalWhereFilters,
  fetchOrders,
  setIsOrderLoading,
}) => {
  const handleFilterChange = (value) => {
    setIsOrderLoading(true);
    setFinalWhereFilters({ ...finalWhereFilters, statusTiming: value });
    // eslint-disable-next-line no-param-reassign
    finalWhereFiltersRef.current = {
      ...finalWhereFiltersRef?.current,
      statusTiming: value,
    };
    fetchOrders();
  };

  return (
    <div>
      <SelectComponent
        className="mr-8 order-status-select"
        placeholder="Select Status Type"
        showAction={['click']}
        showSearch={false}
        options={ORDER_STATUS_OPTIONS}
        onChange={(value) => handleFilterChange(value)}
        allowClear
      />
    </div>
  );
};

export default OrderStatusSelect;
